<div class="card mb-2">
  <div class="card-body">
    <button type="button" routerLink="/payroll/approval" class="btn btn-secondary float-right">Back</button>
    <h2>Payroll Rejection Reasons</h2>

    <div class="row mb-3" *ngIf="canManage">
      <div class="col-12 col-lg-10">
        <textarea class="form-control" rows="2" [(ngModel)]="newReason" placeholder="Reason"></textarea>
      </div>
      <div class="col-12 col-lg-2 mt-2 mt-lg-0">
        <button type="button" class="btn btn-primary w-100" [disabled]="!canAddReason()" (click)="addReason()">Add</button>
      </div>
    </div>

    <i *ngIf="loading" class="material-icons rotate text-muted">loop</i>

    <p-table *ngIf="!loading" [value]="reasons" [responsive]="true">
      <ng-template pTemplate="header">
        <tr>
          <th>Reason</th>
          <th width="120px">Sort</th>
          <th width="100px">Default</th>
          <th width="170px" *ngIf="canManage">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-reason>
        <tr>
          <td>
            <textarea class="form-control reason-text" rows="2" [(ngModel)]="reason.reason"
              [disabled]="reason.isDefault || !canManage"></textarea>
          </td>
          <td>
            <input type="number" class="form-control" [(ngModel)]="reason.sortOrder"
              [disabled]="reason.isDefault || !canManage"/>
          </td>
          <td>
            <span *ngIf="reason.isDefault" class="badge badge-secondary">Default</span>
          </td>
          <td *ngIf="canManage">
            <button type="button" class="btn btn-primary mr-2" [disabled]="!canSaveReason(reason)"
              (click)="saveReason(reason)">Save</button>
            <button type="button" class="btn btn-link text-danger" *ngIf="!reason.isDefault"
              [disabled]="saving" (click)="removeReason(reason)">Remove</button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="canManage ? 4 : 3">No rejection reasons found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
